<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <ng-container>
        <li class="menu-title"> {{ "SIDEBAR.collection" | translate }}</li>
       
        <li [ngClass]="{ 'mm-active' : isActive('/dashboard') }">
          <a routerLink="/dashboard" (click)="toggleMenu($event)" class="side-nav-link-ref">
            <i class="bx bxs-dashboard"></i>
            <span>   {{ "SIDEBAR.dashboard" | translate }} </span>
          </a>
        </li>

        <li *ngIf="permissionService.has('c-communication-view')" [ngClass]="{ 'mm-active' : isActive('/communication') }">
          <a routerLink="/communication/section/progress" (click)="toggleMenu($event)" class="side-nav-link-ref">
            <i class='bx bx-check-square'></i>
            <span> 
              {{ "SIDEBAR.communication" | translate }} 
              <span class="badge p-1 bg-primary float-end chat-counter">{{totalUnreadChats}}</span>
            </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/members') }" *ngIf="permissionService.has('c-member-view')">
          <a routerLink="/members" (click)="toggleMenu($event)" class="side-nav-link-ref">
            <i class="bx bx-user"></i>
            <span>   {{ "SIDEBAR.members" | translate }} </span>
          </a>
        </li>

        <li *ngIf="permissionService.has('c-dossiers-view')" [ngClass]="{ 'mm-active' : isActive('/dossiers') }">
          <a routerLink="/dossiers" (click)="toggleMenu($event)" class="side-nav-link-ref">
            <i class='bx bx-book-open' ></i>
            <span>   {{ "SIDEBAR.dossiers" | translate }} </span>
          </a>
        </li>

        <li *ngIf="permissionService.has('c-mutations-view')" [ngClass]="{ 'mm-active' : isActive('/mutations') }">
          <a routerLink="/mutations" (click)="toggleMenu($event)" class="side-nav-link-ref">
            <i class='bx bx-list-ul' ></i>
            <span>   {{ "SIDEBAR.mutations" | translate }} </span>
          </a>
        </li>

        <li *ngIf="permissionService.has('c-payments-view')" [ngClass]="{ 'mm-active' : isActive('/payments-batch') }">
          <a routerLink="/payments-batch" (click)="toggleMenu($event)" class="side-nav-link-ref">
            <i class='bx bx-book-open' ></i>
            <span>   {{ "SIDEBAR.payments" | translate }} </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/reports') }" *ngIf="permissionService.has('c-reports-view')">
          <a (click)="toggleMenu($event)" routerLink="/reports" class="side-nav-link-ref">
            <i class='bx bx-bar-chart' ></i>
            <span>   {{ "SIDEBAR.reports" | translate }} </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/my-club') }">
          <a routerLink="/my-club" (click)="toggleMenu($event)" class="side-nav-link-ref">
            <i class="bx bx-football"></i>
            <span> {{ "SIDEBAR.my-club" | translate }} </span>
          </a>
        </li>

        <li *ngIf="permissionService.has('c-payment-gateway-view')" [ngClass]="{ 'mm-active' : isActive('/payment-gateway-settings') }">
          <a routerLink="/payment-gateway-settings" (click)="toggleMenu($event)" class="side-nav-link-ref">
            <i class='bx bx-cog' ></i>
              <span> 
                {{ "SIDEBAR.payment-gateway" | translate }}
                @if (!(hasConnect$ | async) && !(hasManualConnect$ | async)) {
                  <span class="float-end payment-gateway-warning"><i class='bx bx-error text-primary'></i></span>
                }
              </span>
          </a>
        </li>

        <li *ngIf="permissionService.has('c-users-view')" [ngClass]="{ 'mm-active' : isActive('/users') }">
          <a routerLink="/users" (click)="toggleMenu($event)" class="side-nav-link-ref">
            <i class='bx bx-group' ></i>
            <span> {{ "SIDEBAR.users" | translate }} </span>
          </a>
        </li>

        <!-- <li [ngClass]="{ 'mm-active' : isActive('/settings') }">
          <a routerLink="/settings" class="side-nav-link-ref">
            <i class="bx bx-cog"></i>
            <span> {{ "SIDEBAR.settings" | translate }} </span>
          </a>
        </li> -->

      </ng-container>
    </ul>
  </div>

</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    @if(isCondensed){
    <div>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    }@else {
    <div>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    }
  </ngx-simplebar>

  <div class="sidebar-footer">
    <div class="sidebar-footer-version">
      <span class="w-100 cursor-pointer" routerLink="/help-and-support/changelog-version"> {{ "SIDEBAR.version" | translate }} {{ appVersion ?? "0.0.0" }}</span>
    </div>

    <div class="sidebar-footer-link">
      <a routerLink="/help-and-support" (click)="toggleMenu($event)" class="side-nav-link-ref" [ngClass]="{ 'active' : isActive('/help-and-support') }">
        <i class="bx bx-support"></i>
        <span> {{ "SIDEBAR.help-and-support" | translate }} </span>
      </a>
    </div>
  </div>
</div>
<!-- Left Sidebar End -->